export const subtract = (a: number, b: number) => a - b;
